/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { DateRangeDto } from "./DateRangeDto.ts"

export const dateFilterDtoOperatorEnum = {
  isEmpty: "isEmpty",
  isNotEmpty: "isNotEmpty",
  between: "between",
  equals: "equals",
  before: "before",
  after: "after",
  notEquals: "notEquals",
  isBeforeOrEquals: "isBeforeOrEquals",
  isAfterOrEquals: "isAfterOrEquals",
  isNotBetween: "isNotBetween",
} as const

export type DateFilterDtoOperatorEnumKey =
  (typeof dateFilterDtoOperatorEnum)[keyof typeof dateFilterDtoOperatorEnum]

export const dateFilterDtoTypeEnum = {
  slider: "slider",
  fixed: "fixed",
} as const

export type DateFilterDtoTypeEnumKey =
  (typeof dateFilterDtoTypeEnum)[keyof typeof dateFilterDtoTypeEnum]

export const dateFilterDtoPresetEnum = {
  today: "today",
  tomorrow: "tomorrow",
  yesterday: "yesterday",
  oneWeekAgo: "oneWeekAgo",
  oneWeekFromNow: "oneWeekFromNow",
  oneMonthAgo: "oneMonthAgo",
  oneMonthFromNow: "oneMonthFromNow",
  oneYearAgo: "oneYearAgo",
  oneYearFromNow: "oneYearFromNow",
  custom: "custom",
} as const

export type DateFilterDtoPresetEnumKey =
  (typeof dateFilterDtoPresetEnum)[keyof typeof dateFilterDtoPresetEnum]

export type DateFilterDto = {
  /**
   * @type string
   */
  operator: DateFilterDtoOperatorEnumKey
  /**
   * @type string
   */
  type: DateFilterDtoTypeEnumKey
  /**
   * @type string
   */
  preset: DateFilterDtoPresetEnumKey
  /**
   * @type object
   */
  range?: DateRangeDto | null
}
